// Feature gating for Free vs Paid (Lifetime) tiers.
// Free tier: Major, all three Minors (natural/harmonic/melodic).
// Free tier chords: Major, Minor, Diminished, Augmented triads.
// Diatonic chord batch export is always free.
// Circle of Fifths, all other scales/chords, and watermark removal require paid.

export const FREE_SCALES = new Set([
  "major",
  "natural_minor",
  "harmonic_minor",
  "melodic_minor",
]);

export const FREE_CHORDS = new Set([
  "maj",
  "min",
  "dim",
  "aug",
]);

export function isScaleFree(key) {
  return FREE_SCALES.has(key);
}

export function isChordFree(key) {
  return FREE_CHORDS.has(key);
}

// A user has paid access when their profile has lifetime_paid === true.
// If no user is signed in, treat them as free-tier.
export function isPaid(user) {
  return Boolean(user && user.lifetime_paid);
}

// Watermark shown on all free-tier PDF exports.
export const WATERMARK_TEXT = "Blueprint of Piano Calling";

export const LIFETIME_PRICE_INR = 399;
